import { useQuery } from "@tanstack/react-query";
import { useAppData } from "../context/Contexts";

const useCaptionsQuery = () => {
    const { currentAppData, setCurrentAppData } = useAppData();

    const {
        status,
        data,
        error,
        isFetching,
        refetch
    } = useQuery({
        queryKey: ['captions'],
        refetchOnWindowFocus: false,
        enabled: false,
        queryFn: ({ }) => fetchCaptions(),
    }
    )

    let Shopify = window.Shopify || {};
    Shopify.country = Shopify.country || 'US';

    const fetchCaptions = async (pageParam = null) => {
        //console.log(key);
        // console.log('pageParam: ');
        // console.log(pageParam);

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");


        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        const response = await fetch("https://shopbiz.wearevisum.com/api/v1/captions", requestOptions)
            .catch(error => console.log('error', error));

        let data = await response.json();

        console.log('data captions', data);

        setCurrentAppData(prevState => {
            return { ...prevState, captions: data.data }
        });

        return data.data
    }

    return {captions_status: status,
        captions_data: data,
        captions_error: error,
        captions_isFetching: isFetching,
        captions_refetch: refetch};
};

export default useCaptionsQuery;